<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-sheet class="card-rounded">
        <v-row no-gutters>
          <!-- ระดับชั้นที่ต้องการสมัคร -->
          <v-col cols="12" class="pa-4">
            <v-row
              no-gutters
              justify="space-between"
              class="mb-3"
              align="center"
            >
              <span class="header-text">{{ $t('message.adminPage.document.documentHeader') }}</span>
              <v-btn
                color="primary"
                small
                text
                class="underline-text"
                @click="downloadAsZip"
                :disabled="allFilesExpired"
              >
              {{ $t('message.adminPage.document.downloadDocument') }}
              </v-btn>
            </v-row>
            <DragDropUploader
              v-if="applicant?.id"
              :is_payment_evidence="false"
              :student_id="applicant?.id"
              :filesProp="applicantInfo?.filesDocument"
              @onUploadFile="onUploadFile"
              @onDeleteFile="onDeleteFile"
              @showAlert="showAlert"
              @loadingUpdate="loadingUpdate"
            >
            </DragDropUploader>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import DragDropUploader from "@/components/admin/Candidates/Applicant/DragDropFiles/DragDropUploader.vue";
import * as services from "@/services";

export default {
  props: {
    applicantInfo: Object,
    currentStep: String,
  },
  components: {
    DragDropUploader,
  },
  computed: {
    allFilesExpired(){
      return this.applicant?.filesDocument?.filter((item) => item.url != null && item.url != '').length > 0 ? false : true
    }
  },
  mounted() {
    this.retrievedData();
  },
  data() {
    return {
      applicant: {},
    };
  },
  methods: {
    loadingUpdate(value) {
      this.$emit("loadingUpdate", value);
    },
    showAlert(status, text) {
      this.$emit("showAlert", status, text);
    },
    retrievedData() {
      let applicant = JSON.parse(JSON.stringify(this.applicantInfo));
      this.applicant = applicant;
    },
    async downloadAsZip() {
      try {
        const downloadFiles = []
        const availableFiles = this.applicantInfo.filesDocument.filter((item) => item.url != null && item.url != '')
        for(let file of availableFiles){
          downloadFiles.push({
            name: file.name,
            url: file.url
          })
        }
        const body = {
          name: "document",
          files: downloadFiles
        };
        console.log(body);
        const res = await services.downloadAsZipFile(body);
        const blob = new Blob([res.data], {
          type: "application/zip",
        });
        const downloadUrl = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.target = "_blank";
        a.href = downloadUrl;
        a.download = "document.zip";
        document.body.appendChild(a);
        a.click();
      
      } catch (error) {
        console.error('Error downloading PDF:', error)
        this.$toast.error(this.$t('message.common.downloadError'));
      }
    },
    onDeleteFile(id){
      this.applicant.filesDocument = this.applicant?.filesDocument.filter((item) => item.id != id);
    },
    onUploadFile(file){
      this.applicant.filesDocument.push(file)
    },
  },
};
</script>

<style scoped lang="scss">
.filepond-custom-action-text {
  color: #ff9800 !important;
  text-decoration: underline !important;
}
.underline-text {
  font-family: "Prompt";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  /* identical to box height, or 133% */

  text-decoration-line: underline;

  /* Primary/Primary 500 - FF9800 */

  /* color: #ff9800; */
}
.header-text {
  font-family: "Prompt";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 23px;
  color: #255d98;
}
.caption-text {
  font-family: "Prompt";
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #9d9b9a;
}
.default-text {
  font-family: "Sarabun";
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  color: #37323c;
}

[class*="-text"] {
    .v-application[lang="en"] & {
        font-family: "inter", sans-serif !important;
    }
}
.card-rounded {
  background: #ffffff;
  box-shadow: 0px 0px 20px rgba(232, 232, 232, 0.7) !important;
  border-radius: 10px 10px 10px 10px;
}
</style>
